import { useContext, useState } from 'react'
import ConfirmAlert from '@comp/confirmAlert'
import { DomainContext } from '@context/DomainContext'
import { successToast } from '@utils/toasters'

export const useBaseHook = (api) => {
    const { setLoading, ToggleReloadTable } = useContext(DomainContext)
    const [isLoading, setIsLoading] = useState(false)
    const onApply = (msg, reqBody, action) => {
        debugger
        setLoading(l => l + 1)
        ConfirmAlert(msg,
            () => {
                setIsLoading(true)
                setLoading(l => l + 1)
                api?.(reqBody)?.then(res => {
                    action?.()
                        
                    ToggleReloadTable(prev => !prev)
                    successToast("Operation done successfully")
                })?.finally(() => {
                    setIsLoading(false)
                    setLoading(l => l - 1)
                }
                )
            },() => {
                setLoading(l => l - 1)
                setIsLoading(false)
            })
    }

    return { onApply, isLoading }
}
